import React, { useEffect, useState } from 'react';

import { Grid } from '@mui/material';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

import Bar from '@/components/BI/graphicBar';
import { Loading } from '@/pages/Common/EnterpriseDetails/EnterprisePage/tabs/Properties/components/GraphGrain/Loading';
import usePropertyService from '@/services/property';
import { useSelector } from 'react-redux';

import { PaperTitle, PaperTitleMore, Container } from '../../styles';
import { convertHarvestInColors } from '@/utils/helpers/harvestGraphColors';

const categoriesMilhoSafra = {
    150: 0,
    160: 0,
    170: 0,
    180: 0,
    190: 0,
    200: 0,
    '+200': 0
};

const categoriesMilhoSafrinha = {
    80: 0,
    100: 0,
    120: 0,
    150: 0,
    180: 0,
    200: 0,
    '+200': 0
};

const categoriesSojaSafra = {
    50: 0,
    60: 0,
    70: 0,
    80: 0,
    90: 0,
    100: 0,
    '+100': 0
};

const categoriesFeijaoSafrinha = {
    20: 0,
    30: 0,
    40: 0,
    50: 0,
    60: 0,
    70: 0,
    '+70': 0
};

const coresPorCultura = {};

const GraphGrain = ({ idEnterprise }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [graphMilhoSafraData, setGraphMilhoSafraData] = useState([]);
    const [graphMilhoSafrinhaData, setGraphMilhoSafrinhaData] = useState([]);
    const [graphSojaSafraData, setGraphSojaSafraData] = useState([]);
    const [graphFeijaoSafrinhaData, setGraphFeijaoSafrinhaData] = useState([]);
    const [dataSumSafra, setDataSumSafra] = useState([]);
    const [doughnutColorsSafra, setDoughnutColorsSafra] = useState([]);
    const [dataSumSafrinha, setDataSumSafrinha] = useState([]);
    const [doughnutColorsSafrinha, setDoughnutColorsSafrinha] = useState([]);

    // const [graphDoughnutSafra, setGraphDoughnutSafra] = useState({
    //     labels: evaluation?.resultByIndicator.map((indicator) => indicator.indicator.name),
    //     datasets: [
    //         {
    //             label: '',
    //             data: evaluation?.resultByIndicator.map((indicator) => indicator.result),
    //             backgroundColor: 'rgba(203, 231, 211, 0.2)',
    //             borderColor: 'rgba(41, 71, 50, 1)',
    //             borderWidth: 1
    //         }
    //     ]
    // });

    const propertyService = usePropertyService();
    const segment = useSelector((state) => state.auth.currentSegment);

    const options = {
        chartArea: { width: '80%', height: '80%' },
        explorer: { axis: 'horizontal', keepInBounds: false },
        orientation: 'horizontal',
        legend: { position: 'none' },
        fontSize: 12,
        tooltip: {
            ignoreBounds: false,
            textStyle: {
                bold: true
            }
        },
        annotations: {
            textStyle: {
                fontSize: 15,
                bold: true,
                color: '#000'
            }
        },
        vAxis: { textPosition: 'none' }
    };

    function somaDosValores(objeto) {
        return Object.values(objeto).reduce((acumulador, valorAtual) => acumulador + parseInt(valorAtual, 10), 0);
    }

    function handleGraphBarData(data) {
        setGraphMilhoSafraData(configureGraphData(categoriesMilhoSafra, '#EFBB00', data['categoriesMilhoSafra']));
        setGraphMilhoSafrinhaData(configureGraphData(categoriesMilhoSafrinha, '#EFBB00', data['categoriesMilhoSafrinha']));
        setGraphSojaSafraData(configureGraphData(categoriesSojaSafra, '#3F968B', data['categoriesSojaSafra']));
        setGraphFeijaoSafrinhaData(configureGraphData(categoriesFeijaoSafrinha, '#DD6A57', data['categoriesFeijaoSafrinha']));
        setDataSumSafra(data['sumCategoriesSafraData']);
        setDataSumSafrinha(data['sumCategoriesSafinhaData']);
        console.log(convertHarvestInColors(Object.keys(dataSumSafra)));
    }

    const doughnutSafraOptions = {
        labels: Object.keys(dataSumSafra),
        datasets: [
            {
                label: 'Propriedades com essa cultura',
                data: Object.values(dataSumSafra),
                backgroundColor: convertHarvestInColors(Object.keys(dataSumSafra)),
                borderColor: convertHarvestInColors(Object.keys(dataSumSafra)),
                borderWidth: 1
            }
        ]
    };

    const doughnutSafrinhaOptions = {
        labels: Object.keys(dataSumSafrinha),
        datasets: [
            {
                label: 'Propriedades com essa cultura',
                data: Object.values(dataSumSafrinha),
                backgroundColor: convertHarvestInColors(Object.keys(dataSumSafrinha)),
                borderColor: convertHarvestInColors(Object.keys(dataSumSafrinha)),
                borderWidth: 1
            }
        ]
    };

    function configureGraphData(categories, color, data) {
        var formattedData = [['Categoria', 'Quantidade', { role: 'style' }, { role: 'annotation' }]];
        var total = somaDosValores(data);
        Object.keys(categories).forEach((category) => {
            const quantity = data[category] ? parseInt(data[category], 10) : 0;
            const annotation = parseInt((quantity / total) * 100);

            formattedData.push([`${category} sc/ha`, quantity, color, `${annotation}%`]);
        });
        return formattedData;
    }

    const handleData = (categoriesMilhoSafra, categoriesMilhoSafrinha, categoriesSojaSafra, categoriesFeijaoSafrinha) => {
        setIsLoading(true);
        propertyService
            .getPropertyByCompany(
                idEnterprise,
                categoriesMilhoSafra,
                categoriesMilhoSafrinha,
                categoriesSojaSafra,
                categoriesFeijaoSafrinha
            )
            .then((resp) => {
                handleGraphBarData(resp);
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setIsLoading(false);
            });
    };

    useEffect(() => {
        handleData(categoriesMilhoSafra, categoriesMilhoSafrinha, categoriesSojaSafra, categoriesFeijaoSafrinha);
    }, []);

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <Grid container spacing={3}>
                <Container>
                    <Grid item xs={12}>
                        <PaperTitleMore>Sistema de produção da Safra</PaperTitleMore>
                    </Grid>

                    <Grid item xs={12} height={'20.5rem'} style={{ display: 'flex', justifyContent: 'center' }}>
                        {Object.keys(dataSumSafra).length > 0 && <Doughnut data={doughnutSafraOptions} />}
                    </Grid>
                    {/* <Grid item xs={6} height={'20.5rem'}>
                    {graphBarData.length > 0 && <Bar height="100%" width="100%" allData={graphBarData} options={options} />}
                </Grid> */}
                </Container>

                <Container>
                    <Grid item xs={12}>
                        <PaperTitleMore>Sistema de produção da Safrinha</PaperTitleMore>
                    </Grid>

                    <Grid item xs={12} height={'20.5rem'} style={{ display: 'flex', justifyContent: 'center' }}>
                        {Object.keys(dataSumSafrinha).length > 0 && <Doughnut data={doughnutSafrinhaOptions} />}
                    </Grid>
                    {/* <Grid item xs={6} height={'20.5rem'}>
                    {graphBarData.length > 0 && <Bar height="100%" width="100%" allData={graphBarData} options={options} />}
                </Grid> */}
                </Container>
            </Grid>

            <Grid container spacing={3}>
                <Container>
                    <Grid item xs={12}>
                        <PaperTitleMore>Milho Safra</PaperTitleMore>
                        <PaperTitle>Nível das Propriedades / Produtividade</PaperTitle>
                    </Grid>

                    <Grid item xs={12} height={'20.5rem'}>
                        {graphMilhoSafraData.length > 0 && (
                            <Bar height="100%" width="100%" allData={graphMilhoSafraData} options={options} />
                        )}
                    </Grid>
                    {/* <Grid item xs={6} height={'20.5rem'}>
                    {graphBarData.length > 0 && <Bar height="100%" width="100%" allData={graphBarData} options={options} />}
                </Grid> */}
                </Container>

                <Container>
                    <Grid item xs={12}>
                        <PaperTitleMore>Milho Safrinha</PaperTitleMore>
                        <PaperTitle>Nível das Propriedades / Produtividade</PaperTitle>
                    </Grid>

                    <Grid item xs={12} height={'20.5rem'}>
                        {graphMilhoSafrinhaData.length > 0 && (
                            <Bar height="100%" width="100%" allData={graphMilhoSafrinhaData} options={options} />
                        )}
                    </Grid>
                    {/* <Grid item xs={6} height={'20.5rem'}>
                    {graphBarData.length > 0 && <Bar height="100%" width="100%" allData={graphBarData} options={options} />}
                </Grid> */}
                </Container>
            </Grid>

            <Grid container spacing={3}>
                <Container>
                    <Grid item xs={12}>
                        <PaperTitleMore>Soja Safra</PaperTitleMore>
                        <PaperTitle>Nível das Propriedades / Produtividade</PaperTitle>
                    </Grid>

                    <Grid item xs={12} height={'20.5rem'}>
                        {graphSojaSafraData.length > 0 && <Bar height="100%" width="100%" allData={graphSojaSafraData} options={options} />}
                    </Grid>
                    {/* <Grid item xs={6} height={'20.5rem'}>
                    {graphBarData.length > 0 && <Bar height="100%" width="100%" allData={graphBarData} options={options} />}
                </Grid> */}
                </Container>

                <Container>
                    <Grid item xs={12}>
                        <PaperTitleMore>Feijão Safrinha</PaperTitleMore>
                        <PaperTitle>Nível das Propriedades / Produtividade</PaperTitle>
                    </Grid>

                    <Grid item xs={12} height={'20.5rem'}>
                        {graphFeijaoSafrinhaData.length > 0 && (
                            <Bar height="100%" width="100%" allData={graphFeijaoSafrinhaData} options={options} />
                        )}
                    </Grid>
                    {/* <Grid item xs={6} height={'20.5rem'}>
                    {graphBarData.length > 0 && <Bar height="100%" width="100%" allData={graphBarData} options={options} />}
                </Grid> */}
                </Container>
            </Grid>
        </>
    );
};

export default GraphGrain;
